import { render, staticRenderFns } from "./SimplePaymentMethod.vue?vue&type=template&id=3e685e88&scoped=true&"
import script from "./SimplePaymentMethod.vue?vue&type=script&lang=js&"
export * from "./SimplePaymentMethod.vue?vue&type=script&lang=js&"
import style0 from "./SimplePaymentMethod.vue?vue&type=style&index=0&id=3e685e88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e685e88",
  null
  
)

export default component.exports